import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { Audience } from '../model/audience';
import { AudienceService } from '../services/audience.service';

@Component({
  selector: 'app-audiences',
  templateUrl: './audiences.component.html',
  styleUrls: ['./audiences.component.css']
})
export class AudiencesComponent implements OnInit {
  audiences: Audience[];
  selectedAudience: Audience;

  constructor(private service: AudienceService) { }

  ngOnInit() {
    this.service.getAudiences()
      .subscribe((result: Audience[]) => {
        this.audiences = result;
    });
  }

  onSelect(audience: Audience) {
    this.selectedAudience = audience;
  }

  onNewAudience(audienceName: string) {
    this.service.createAudience(audienceName)
      .subscribe((result: Audience) => {
        this.audiences.push(result);
      });
  }

  onUpdate(audienceName: string) {
    this.service.updateAudience(this.selectedAudience)
      .subscribe();
  }

  onDelete(audience: Audience) {
    this.service.deleteAudience(audience.ClientId)
      .subscribe(result => {
        if (audience === this.selectedAudience) {
          this.selectedAudience = null;
        }
        const index = this.audiences.indexOf(audience);
        this.audiences.splice(index, 1);
      });
  }

  onNewSecret(audience: Audience) {
    this.service.createNewSecret(audience.ClientId)
      .subscribe((result: Audience) => {
        audience.Base64Secret = result.Base64Secret;
        if (this.selectedAudience === result) {
          this.selectedAudience.Base64Secret = result.Base64Secret;
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/audiences/audiences.component.ts